import { Files } from "lucide-react";

const manifest = {
  key: "contracts_management",
  isFreeModule: false,
  isPurchasable: true,
  icon: Files,
  names: {
    plan: {
      en: "Contracts Management",
      ar: "\u0625\u062f\u0627\u0631\u0629 \u0627\u0644\u0639\u0642\u0648\u062f",
    },
    dashboard: {
      en: "Contracts Management",
      ar: "\u0625\u062f\u0627\u0631\u0629 \u0627\u0644\u0639\u0642\u0648\u062f",
    },
  },
  defaultPath: "/contracts-dashboard",
  matchers: [
    /^\/contracts-management(?:\/)?$/,
    /^\/contracts-management\/create(?:\/|$)/,
    /^\/contracts-management\/issued(?:\/|$)/,
    /^\/contracts-management\/incoming(?:\/|$)/,
    /^\/contracts-management\/approved(?:\/|$)/,
    /^\/contracts-management\/(?!create(?:\/|$)|issued(?:\/|$)|incoming(?:\/|$)|approved(?:\/|$))[^/]+(?:\/|$)/,
    /^\/contracts-dashboard(?:\/|$)/,
    /^\/contracts-approvals(?:\/|$)/,
  ],
  buildNavbarMenus: ({ t, activeModuleLabel }) => [
    {
      label: activeModuleLabel,
      path: "__contracts_management__",
      children: [
        { label: t("contracts_menu_dashboard_label") || "Dashbord", path: "/contracts-dashboard" },
        {
          label: t("menu_create_contract") || "Create New Contract",
          path: "/contracts-management/create",
          permissions: ["create_contract_draft"],
        },
        {
          label: t("menu_issued_contracts") || "Issued Contracts",
          path: "/contracts-management/issued",
          permissions: ["view_issued_contracts"],
        },
        {
          label: t("contracts_incoming_page_title") || "Incoming Contracts",
          path: "/contracts-management/incoming",
        },
        {
          label: t("menu_contracts_approvals") || "Contracts Approvals",
          path: "/contracts-approvals",
          permissions: ["view_contract_approval_requests", "approve_reject_contract"],
        },
      ],
    },
  ],
};

export default manifest;
